import STORE from '../../store';
import invalidateMetricCache from './invalidateMetricCache';

const createMetric = async (
  metric: Metrics.NormalMetric,
  selectedAccountId: string,
) => {
  await STORE.metricDefinitions
    .getNormalMetricsRef({ accountId: selectedAccountId })
    .doc(metric.id)
    .set(metric);

  await invalidateMetricCache({
    accountId: selectedAccountId,
    normalMetricIds: [metric.id],
  });
};

export default createMetric;
